import { render, staticRenderFns } from "./HowDoesItWorkVideo.vue?vue&type=template&id=7d1fb4bd&scoped=true&"
import script from "./HowDoesItWorkVideo.vue?vue&type=script&lang=js&"
export * from "./HowDoesItWorkVideo.vue?vue&type=script&lang=js&"
import style0 from "./HowDoesItWorkVideo.vue?vue&type=style&index=0&id=7d1fb4bd&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1fb4bd",
  null
  
)

export default component.exports